import { ExtensionType } from '../../../extensions/Extensions.mjs';

"use strict";
class GpuStencilSystem {
  constructor(renderer) {
    this._renderer = renderer;
    renderer.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange() {
    this._activeGpuRenderTarget = null;
  }
  onRenderTargetChange(renderTarget) {
    const gpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(renderTarget);
    this._activeRenderTarget = renderTarget;
    this._activeGpuRenderTarget = gpuRenderTarget;
    this.setStencilMode(gpuRenderTarget.stencilMode, gpuRenderTarget.stencilReference);
  }
  setStencilMode(stencilMode, stencilReference) {
    const gpuRenderTarget = this._activeGpuRenderTarget ?? (this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget));
    gpuRenderTarget.stencilMode = stencilMode;
    gpuRenderTarget.stencilReference = stencilReference;
    const renderer = this._renderer;
    renderer.pipeline.setStencilMode(stencilMode);
    renderer.encoder.setStencilReference(stencilReference);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this);
    this._renderer = null;
    this._activeRenderTarget = null;
    this._activeGpuRenderTarget = null;
  }
}
/** @ignore */
GpuStencilSystem.extension = {
  type: [
    ExtensionType.WebGPUSystem
  ],
  name: "stencil"
};

export { GpuStencilSystem };
//# sourceMappingURL=GpuStencilSystem.mjs.map
